const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

async function request(path, options = {}, studioKey = '') {
  const headers = {
    Accept: 'application/json',
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(options.headers || {}),
    ...(studioKey ? { 'X-Studio-Key': studioKey } : {}),
  };

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  const text = await response.text();
  const payload = text ? JSON.parse(text) : {};

  if (!response.ok) {
    throw new Error(payload.message || 'Request failed.');
  }

  return payload;
}

export function fetchPortfolio() {
  return request('/api/portfolio');
}

export function updateProfile(profile, studioKey) {
  return request(
    '/api/profile',
    {
      method: 'PUT',
      body: JSON.stringify(profile),
    },
    studioKey
  );
}

export function createItem(item, studioKey) {
  return request(
    '/api/items',
    {
      method: 'POST',
      body: JSON.stringify(item),
    },
    studioKey
  );
}

export function updateItem(itemId, item, studioKey) {
  return request(
    `/api/items/${itemId}`,
    {
      method: 'PUT',
      body: JSON.stringify(item),
    },
    studioKey
  );
}

export function removeItem(itemId, studioKey) {
  return request(
    `/api/items/${itemId}`,
    {
      method: 'DELETE',
    },
    studioKey
  );
}

export function sendChatMessage(message) {
  return request('/api/chat', {
    method: 'POST',
    body: JSON.stringify({ message }),
  });
}
